import { connect } from 'react-redux';
import { Link } from 'react-router';
import { LinearProgress, Typography } from '@mui/material';
import { stableSort, compareByProps } from '../../utils/comparators';
import { Row } from '../util/Page';
import DataAlertsLoader from '../loaders/DataAlertsLoader';
import AlertDashboardRow from './AlertDashboardRow';

const anyOverlap = (filterBuildings, alertBuildings) => {
  if (filterBuildings.length === 0 || alertBuildings?.length === 0) {
    return true;
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const bid of filterBuildings) {
    if (alertBuildings?.indexOf(bid) !== -1) {
      return true;
    }
  }
  return false;
};

const DataAlertStatus = ({ buildings, loaded, alerts }) => {
  if (!loaded) {
    return (
      <Row>
        <DataAlertsLoader />
        <LinearProgress className="loading" color="secondary" />
      </Row>
    );
  }
  if (!alerts.length) {
    return (
      <Row>
        <Typography variant="h5">
          No alerts yet, create one on the <Link to="/data-alerts">monitoring page</Link>
        </Typography>
      </Row>
    );
  }
  const errorsFirst = stableSort(alerts, compareByProps(['state'])).filter((alert) =>
    anyOverlap(buildings, alert.buildings)
  );
  return errorsFirst.map((alert) => (
    <AlertDashboardRow buildings={buildings} key={alert.id} alert={alert} />
  ));
};

export default connect(
  ({
    entities: {
      dataAlerts: { loaded, alerts },
    },
  }) => ({ loaded, alerts })
)(DataAlertStatus);
